/**
 * PageTransition - Smooth page transitions wrapper
 *
 * Wraps page content with framer-motion animations based on navigation direction
 */
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useNavigationStack } from '../../contexts/NavigationContext';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const { getTransitionMetadata } = useNavigationStack();

  const metadata = getTransitionMetadata();
  const direction = metadata.direction || 'forward';

  // Animation variants based on direction
  const variants = {
    forward: {
      initial: { x: '100%', opacity: 0 },
      animate: { x: 0, opacity: 1 },
      exit: { x: '-30%', opacity: 0 }
    },
    back: {
      initial: { x: '-30%', opacity: 0 },
      animate: { x: 0, opacity: 1 },
      exit: { x: '100%', opacity: 0 }
    },
    modal: {
      initial: { scale: 0.95, opacity: 0, y: 20 },
      animate: { scale: 1, opacity: 1, y: 0 },
      exit: { scale: 0.95, opacity: 0, y: 20 }
    },
    none: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 }
    }
  };

  const currentVariant = variants[direction] || variants.forward;

  // Spring configuration for smooth, natural motion
  const spring = {
    type: 'spring',
    stiffness: 300,
    damping: 30
  };

  // Check if we're on the chat page (needs full height, no scroll)
  const isChatPage = location.pathname === '/chat/leo';

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={currentVariant.initial}
        animate={currentVariant.animate}
        exit={currentVariant.exit}
        transition={spring}
        style={{
          width: '100%',
          height: isChatPage ? '100%' : 'auto',
          minHeight: isChatPage ? 'unset' : '100vh'
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;


